import React, {Component} from "react"
import '../../node_modules/flickity/dist/flickity.min.css';

import pic1 from '../images/instalaciones-1.jpg'
import pic2 from '../images/instalaciones-2.jpg'
import pic3 from '../images/instalaciones-3.jpg'
import pic4 from '../images/instalaciones-4.jpg'

const isBrowser = typeof window !== 'undefined';
const Flickity = isBrowser ? require('react-flickity-component') : 'div';

const instalacionesGaleria = [
	{ img: pic1 },
	{ img: pic2 },
	{ img: pic3 },
	{ img: pic4 },
]

class Instalaciones extends Component{
	render(){
		const flickityOptions = {
			initialIndex: 0,
			adaptiveHeight: true,
			imagesLoaded: true,
			pageDots: false,
			cellAlign: 'left',
			freeScroll: true,
			wrapAround: true
			// autoPlay: true
		}
		return(
			<div className="carousel-instalaciones">
				<Flickity
					className={'carousel'} // default ''
					elementType={'div'} // default 'div'
					options={flickityOptions} // takes flickity options {}
					reloadOnUpdate={true} // default false
					>
					{instalacionesGaleria.map((item, index) => (
						<div className="item" key={index}>
							<img src={item.img} alt="Instalaciones"/>
						</div>
					))}
				</Flickity>
			</div>
		)
	}
}

export default Instalaciones
